export default "__VITE_ASSET__CNgrdjFw__"